import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { createElement } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * コンサルタント向けの、案件リード情報の行コンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalOneLeadRow = (props) => {
    const { children, className = '', icon, title } = props;
    return (_jsxs("div", Object.assign({ className: clsx('flex', 'py-[10px] gap-x-12', 'border-x-0 border-t-0 border-b border-solid border-b-light', 'bg-white') }, { children: [_jsxs(IconTextGroup, Object.assign({ className: clsx('max-w-[120px] w-full', className) }, { children: [createElement(icon, { className: 'flex', color: 'base', size: 'sm' }), _jsx(Text, Object.assign({ color: 'base', size: 'sm', tagName: 'div' }, { children: title }))] })), _jsx("div", Object.assign({ className: 'pr-8' }, { children: children }))] })));
};
